import * as Yup from 'yup';

export const createNotificationSchema = Yup.object().shape({
  title: Yup.object().shape({
    uz: Yup.string().required('Sarlavha (uz) majburiy'),
    ru: Yup.string().required('Sarlavha (ru) majburiy'),
    en: Yup.string().required('Sarlavha (en) majburiy'),
  }),
  message: Yup.object().shape({
    uz: Yup.string().required('Matn (uz) majburiy'),
    kril: Yup.string().required('Matn (kril) majburiy'),
    en: Yup.string().required('Matn (en) majburiy'),
  }),
});